"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isVersionGreaterThanOrEqualTo18 = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
var isVersionGreaterThanOrEqualTo18 = function isVersionGreaterThanOrEqualTo18() {
  return react_dom_1["default"].version && parseInt(react_dom_1["default"].version.split('.')[0], 10) >= 18 || false;
};
exports.isVersionGreaterThanOrEqualTo18 = isVersionGreaterThanOrEqualTo18;
exports["default"] = exports.isVersionGreaterThanOrEqualTo18();